<template>
  <div>
    <el-dialog
      title="结算方式"
      :visible.sync="visible"
      width="30%"
      class="settlement_dialog"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div>
        <span class="settlement_tips">请选择结算方式</span>
        <div class="settlement_content">
          <span 
          v-for="item in settlementTypeOption" 
          :key="item.value" 
          class="settlement_item"
          :class="{'disabled_item':item.disabled,'active_item':settlementType===item.value}"
          @click="handleClick(item)">
          <span>{{ item.label }}</span>
          <img class="settlement_item_icon" :src="iconUrl(item)" />
        </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <a-button class="dialog_btn" @click="handleClose">取 消</a-button>
        <a-button class="dialog_btn" type="primary" @click="handleConfirm">确 定</a-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import contractActive from '@/assets/img/contract_active.png'
import contract from '@/assets/img/contract.png'
import immediately from '@/assets/img/immediately.png'
import immediatelyActive from '@/assets/img/immediately_active.png'

  const settlementTypeOption = [
    {
      label:'合约结算',
      value: 1,
      defaultIcon:contract,
      activeIcon:contractActive,
    },
    {
      label:'现结',
      value: 2,
      disabled: true,
      defaultIcon:immediately,
      activeIcon:immediatelyActive,
    },
  ]
  export default {
    name:'SettlementModes',
    data(){
      return{
        settlementTypeOption,
        visible: false,
        settlementType: 1,
        resolveFunc:null,
        rejectFunc:null,
      }
    },
    computed:{
      iconUrl(){
        return (item)=>{
          return this.settlementType === item.value?item.activeIcon:item.defaultIcon
        }
      }
    },
    methods:{
      show(){
        this.visible = true; 
        return new Promise((resolve, reject) => {
          this.resolveFunc = resolve;
          this.rejectFunc = reject;
        })
      },
      handleClose(){
        this.rejectFunc();
        this.visible = false;
      },
      handleConfirm(){
        this.resolveFunc();
        this.handleClose();
      },
      handleClick(item){
        if(item.disabled) return;
        this.settlementType = item.value;
      }
    }
  }
</script>

<style lang="less" scoped>
.settlement_tips{
  margin-bottom: 8px;
  display: inline-block;
}
.settlement_content{
  display: flex;
  align-items: center;
  .settlement_item{
    padding: 0 24px;
    height: 110px;
    display: inline-flex;
    flex: 1;
    border-radius: 6px;
    border: 1px solid #E6EAF0;
    margin-right: 24px;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    align-items: center;
    justify-content: space-between;
    color: #505762;
    cursor: pointer;
  } 
  .settlement_item_icon{
    width: 58px;
    height: 58px;
  }
  .settlement_item:last-child{
    margin-right: 0px;
  }
  .active_item{
    color: #fff;
    border: 1px solid #25B195;
    background: linear-gradient(221deg, #06F1C9 0%, #01AE84 100%);
    box-shadow: 0px 13px 16px 5px rgba(9, 222, 158, 0.29), 0px 4px 7px 0px rgba(115, 250, 238, 0.36);
  }
  .disabled_item{
    color: #B0B7C2;
    border: 1px solid var(--light-light-el-border-color-light, #E6EAF0);
    background: var(--light-light-el-border-color-lighter, #F0F2F5);
  }
}
.dialog-footer{
  .dialog_btn{
    margin-left: 12px;
  }
}
::v-deep .settlement_dialog{
  .el-dialog{
    min-width: 460px;
  }
}
</style>